import { usePoliciesFiltering } from "hooks/usePoliciesFiltering";
import { useRowPagination } from "hooks/useRowPagination";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { useSearchParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  stringFormatingToPascal,
  getBadgeText,
  getBadgeClassByPolicyStatus,
  getPolicyType,
  getName,
} from "js/formatting";

import AgentSendReminderModal from "components/AgentPortal/ModalDialogs/AgentSendReminderModal";
import FilterDialog from "components/AgentPortal/BookOfBusiness/FilterDialog";
import PolicyLookup from "components/AgentPortal/General/PolicyLookup";
import SimpleDataRow from "components/General/SimpleDataRow";
import RowPagination from "components/General/RowPagination";
import { Trans, useTranslation } from "react-i18next";

export default function PolicyLookUp() {
  const MAXIMUM_PER_PAGE = 5;
  let location = useLocation();
  const { user } = useSelector((state) => state.user);
  let [searchParams, setSearchParams] = useSearchParams();
  const [policyId, setPolicyId] = useState();
  const [policyLookUpData, setPolicyLookUpData] = useState([]);
  const [filteredPolicyLookUpData, setFilteredPolicyLookUpData] = useState([]);
  const [keyword, setKeyword] = useState();
  const [type, setType] = useState();
  const [paymentStatus, setPaymentStatus] = useState();
  const [policyType, setPolicyType] = useState();
  const { policies } = usePoliciesFiltering(
    keyword,
    type,
    paymentStatus,
    policyType
  );
  const { t } = useTranslation();
  useEffect(() => {
    let key = searchParams.get("keyword");
    let type = searchParams.get("type");
    let paymentStatus = searchParams.get("paymentStatus");
    let policyType = searchParams.get("policyType");
    setType(type);
    setPaymentStatus(paymentStatus);
    setKeyword(key);
    setPolicyType(policyType);
  }, [searchParams, location.pathname]);
  useEffect(() => {
    setPolicyLookUpData(policies);
  }, [keyword, policies]);
  useEffect(() => {
    let policies = [];
    if (policyLookUpData?.length > 0) {
      policyLookUpData?.forEach((policy) => {
        let party = policy?.parties?.find(
          (x) => x.person?.type?.toLowerCase() === "primary owner"
        );
        let insuredParty = policy?.parties?.find(
          (x) => x.person?.type.toLowerCase() === "insured"
        );
        let filteresPolicy = {
          payment: policy?.paymentStatus,
          banner: getBadgeClassByPolicyStatus(policy),
          badgeStatus: getBadgeClassByPolicyStatus(policy),
          badgeSrText: getBadgeText(policy),
          badgeText: getBadgeText(policy),
          policyNumber: policy?.contractID,
          oldPolicy: policy?.oldPolicy,
          policyTitle: getName(party?.person),
          insuredName: getName(insuredParty?.person),
          coverage: policy?.cashValue?.currentFaceAmount,
          productName: policy?.product?.description,
          value: policy?.cashValue?.returnofpremiumbenefitAmount ?? "0.00",
          cta: "detail",
          product: policy?.product,
        };
        policies.push(filteresPolicy);
      });
      setFilteredPolicyLookUpData(policies);
    } else {
      setFilteredPolicyLookUpData([]);
    }
  }, [policyLookUpData, user]);
  const { rowsForDisplay: current, rowPaginationProps } = useRowPagination(
    filteredPolicyLookUpData
  );
  const [filterDialogOpen, setFilterDialogOpen] = useState(false);
  const [isOpenSendReminder, setIsOpenSendReminder] = useState(false);
  useBreadcrumb([]);

  return (
    <>
      <div className="container mb-8">
        <h1>{t("AgentPolicyLookup-title")}</h1>
        <p>{t("AgentPolicyLookup-FindCustomerPolicies")}</p>
        <hr />
      </div>

      <div className="container ui-component-spacing">
        <div className="text-sm max-w-[480px]">
          <PolicyLookup />
        </div>
      </div>

      <div className="container ui-component-spacing">
        <h2>Results ({policyLookUpData?.length})</h2>
        <p className="text-sm">View all results</p>
        <hr />

        {policyLookUpData?.length > 0 && (
          <>
            <div className="mx-2 flex items-centers justify-end md:mx-4">
              <button
                className="ui-btn-primary flex items-center"
                onClick={() => setFilterDialogOpen(true)}
              >
                <svg
                  className="ui-icon w-3.5 h-3.5 mr-2"
                  focusable="false"
                  aria-hidden="true"
                  role="presentation"
                >
                  <use href="#ui-icon-filter"></use>
                </svg>
                {t("AgentPolicyLookup-FilterOptions")}
              </button>
            </div>
            {current?.map((policy, idx) => {
              return (
                <SimpleDataRow
                  key={`policy-look-up-result-${idx}`}
                  data={policy}
                  type="policyResult"
                  isOpenSendReminder={isOpenSendReminder}
                  setIsOpenSendReminder={setIsOpenSendReminder}
                  setPolicyId={setPolicyId}
                />
              );
            })}
            <RowPagination {...rowPaginationProps} />
          </>
        )}
      </div>

      <FilterDialog
        dialogState={filterDialogOpen}
        setDialogState={setFilterDialogOpen}
      />
      {/* Send customer a reminder Dialog */}
      <AgentSendReminderModal
        isOpenSendReminder={isOpenSendReminder}
        setIsOpenSendReminder={setIsOpenSendReminder}
        policyId={policyId}
      />
    </>
  );
}
